import React from 'react'

const BRAND_PINK = '#FF4081';
const CARD_BORDER = '#6b6b6b';
const LABEL_COLOR = '#2f2f2f';
const VALUE_COLOR = '#4a4a4a';
const SALES_QTY_COLUMN = 4;
const SALES_VALUE_COLUMN = 5;
const MARGIN_VALUE_COLUMN = 6;
const MARGIN_PERC_COLUMN = 7;
const SALES_SHARE_COLUMN = 8;
const MARGIN_SHARE_COLUMN = 9;

const CARD_BODY_FIELDS = [
    { columnIndex: SALES_QTY_COLUMN, label: 'Qty' },
    { columnIndex: SALES_VALUE_COLUMN, label: 'Sales' },
    { columnIndex: MARGIN_VALUE_COLUMN, label: 'Margin' },
    { columnIndex: MARGIN_PERC_COLUMN, label: 'Margin %' },
];

const getValueByColumn = (values = [], columnIndex) => values.find((item) => item.columnIndex === columnIndex);

const getHeaderValueText = (item) => {
    if (!item) {
        return null;
    }

    if (Number(item.value) === 0) {
        return '-';
    }

    return item.displayValue ? `${item.displayValue} %` : `${Math.round(item.value)} %`;
};

const InsightPyramidCardView = ({ card, isClickable = false, isExpanded = false, onClick }) => {
    if (!card) {
        return null;
    }

    const salesShare = getValueByColumn(card.values, SALES_SHARE_COLUMN);
    const marginShare = getValueByColumn(card.values, MARGIN_SHARE_COLUMN);
    const bodyValues = CARD_BODY_FIELDS
        .map((field) => {
            const item = getValueByColumn(card.values, field.columnIndex);

            return item ? { ...item, displayLabel: field.label } : null;
        })
        .filter(Boolean);
    const salesShareText = getHeaderValueText(salesShare);
    const marginShareText = getHeaderValueText(marginShare);

    return (
        <div style={{
            width: 180,
            border: `1px solid ${CARD_BORDER}`,
            background: '#fff',
            marginBottom: 16,
            fontSize: 12,
            boxShadow: isExpanded ? '0 0 0 2px rgba(255, 64, 129, 0.18)' : 'none',
            cursor: isClickable ? 'pointer' : 'default',
        }} onClick={onClick}>
            <div style={{
                padding: '6px 8px',
                background: '#fff',
                borderBottom: `1px solid ${CARD_BORDER}`,
            }}>
                <div style={{
                    fontWeight: 700,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 8,
                }}>
                    <span style={{ color: BRAND_PINK, flex: '1 1 auto', minWidth: 0 }}>
                        {card.label}
                    </span>
                    {salesShareText && marginShareText ? (
                        <span style={{
                            flex: '0 0 auto',
                            textAlign: 'right',
                            whiteSpace: 'nowrap',
                        }}>
                            <span style={{ color: salesShare?.textColor || LABEL_COLOR }}>
                                {salesShareText}
                            </span>
                            <span style={{ color: LABEL_COLOR }}> / </span>
                            <span style={{ color: marginShare?.textColor || LABEL_COLOR }}>
                                {marginShareText}
                            </span>
                        </span>
                    ) : null}
                    {isClickable ? (
                        <span style={{ color: BRAND_PINK, flex: '0 0 auto', lineHeight: 1 }}>
                            {isExpanded ? '-' : '+'}
                        </span>
                    ) : null}
                </div>
            </div>
            <div style={{ padding: '6px 8px' }}>
                {bodyValues.map((item) => (
                    <div key={item.columnIndex} style={{ marginBottom: 4, display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                        <span style={{ fontWeight: 700, color: LABEL_COLOR }}>{item.displayLabel}</span>
                        <span style={{ color: item.textColor || VALUE_COLOR, textAlign: 'right' }}>{item.displayValue || item.value}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default InsightPyramidCardView